import { baseURL } from "../../util/Constant";
import { getFabricFile } from "../redux/fabricSlice";
import { getMessage } from "../redux/messageSlice";

//Get Image FIle
export const getFabricFileFetch = () => (dispatch) => {
  fetch(`${baseURL}/fabric/get`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      dispatch(getFabricFile(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const putUpdateFabricFetch = (item) => (dispatch) => {
  
  fetch(`${baseURL}/fabric/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      return res.json();
    })
    .then((data) => {
      // Handle successful JSON response
    })
    .catch((error) => {
      // Handle error
      console.error('Error:', error);
    });
};

export const putNewFabricFetch = (item) => (dispatch) => {
  
  fetch(`${baseURL}/fabric/new`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      return res.json();
    })
    .then((data) => {
      // Handle successful JSON response
    })
    .catch((error) => {
      // Handle error
      console.error('Error:', error);
    });
};

export const putPlusMetrsFetch = (newMetrs, fabricName) => async (dispatch) => {
  try {
    if (!newMetrs || !fabricName) {
      throw new Error('Missing required parameters');
    }

    const res = await fetch(`${baseURL}/fabric/plus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ newMetrs, fabricName }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || 'Failed to update meters');
    }

    if (data.success) {
      dispatch(getFabricFileFetch());
      return data;
    } else {
      throw new Error(data.error || 'Failed to update meters');
    }
  } catch (error) {
    console.error('Error updating meters:', error);
    throw error;
  }
};

export const putMinusMetrsFetch = (minusMetrs, fabricName) => async (dispatch) => {
  try {
    if (!minusMetrs || !fabricName) {
      throw new Error('Missing required parameters');
    }

    const res = await fetch(`${baseURL}/fabric/minus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ minusMetrs, fabricName }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || 'Failed to reduce meters');
    }

    if (data.success) {
      dispatch(getFabricFileFetch());
      return data;
    } else {
      throw new Error(data.error || 'Failed to reduce meters');
    }
  } catch (error) {
    console.error('Error reducing meters:', error);
    throw error;
  }
};

export const putUpdateMetrsFetch = (folderFabric, fileName) => async (dispatch) => {
  try {
    if (!folderFabric || !fileName) {
      throw new Error('Missing required parameters');
    }

    const res = await fetch(`${baseURL}/fabric/updateMetrs`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ folderFabric, fileName }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || 'Failed to update meters');
    }

    if (data.success) {
      dispatch(getFabricFileFetch());
      return data;
    } else {
      throw new Error(data.error || 'Failed to update meters');
    }
  } catch (error) {
    console.error('Error updating meters:', error);
    throw error; // Пробрасываем ошибку дальше для обработки в компоненте
  }
};